var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M998 783L998 811",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 998.5,
    cy: 778.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.83 775.888L999.354 772.027C999.278 771.991 999.202 771.991 999.126 772.027L988.651 775.888C988.651 775.888 988.651 775.888 988.632 775.888C988.613 775.888 988.613 775.906 988.594 775.906C988.594 775.906 988.575 775.906 988.575 775.923C988.556 775.923 988.556 775.941 988.537 775.941C988.537 775.941 988.537 775.941 988.518 775.959C988.499 775.976 988.499 775.976 988.48 775.994C988.48 776.012 988.461 776.012 988.461 776.03V776.047C988.461 776.065 988.461 776.065 988.442 776.083V776.1C988.442 776.118 988.442 776.136 988.442 776.154V780.741C987.626 780.883 987 781.556 987 782.353C987 783.256 987.797 784 988.765 784C989.733 784 990.53 783.256 990.53 782.353C990.53 781.538 989.903 780.883 989.087 780.741V776.579L991.118 777.323V780.387C991.118 781.272 991.991 782.087 993.604 782.689C995.122 783.238 997.115 783.557 999.24 783.557C1001.37 783.557 1003.38 783.256 1004.88 782.689C1006.47 782.105 1007.36 781.29 1007.36 780.387V777.323L1009.81 776.419C1009.92 776.384 1010 776.277 1010 776.154C1010 776.03 1009.94 775.941 1009.83 775.888ZM989.922 782.353C989.922 782.937 989.41 783.415 988.784 783.415C988.158 783.415 987.645 782.937 987.645 782.353C987.645 781.768 988.158 781.29 988.784 781.29C989.41 781.29 989.922 781.768 989.922 782.353ZM1006.75 780.404C1006.75 781.662 1003.74 782.99 999.24 782.99C994.743 782.99 991.725 781.644 991.725 780.404V777.553L999.126 780.28C999.164 780.298 999.202 780.298 999.24 780.298C999.278 780.298 999.316 780.298 999.354 780.28L1006.75 777.553V780.404ZM1006.94 776.88L999.24 779.714L991.535 776.862L989.6 776.154L999.24 772.593L1008.88 776.154L1006.94 776.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool2);
export default __webpack_public_path__ + "static/media/school_2.98235d037022f940a0f3811be55cbd91.svg";
export { ForwardRef as ReactComponent };